export default __webpack_public_path__ + "static/media/navbar-icon-inventories.782c9431.svg";